var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kanban"},[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.url,"alt":""}}),_c('span',{staticClass:"son",on:{"click":_vm.handleFullScreen}})])}
var staticRenderFns = []

export { render, staticRenderFns }